import { BaseTool } from '../BaseTool';

export class ObjectStylesTool extends BaseTool {
    id = 'MANAGE_OBJECT_STYLES';
    name = 'Object Styles';
    cursor = 'default';

    onActivate(): void {
        this.context?.appStore.openManageDialog('objectStyles');
        this.context?.appStore.setActiveTool('select');
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}
